import script from "./ContactsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactsView.vue?vue&type=script&setup=true&lang=js"

import "./ContactsView.vue?vue&type=style&index=0&id=7c4781b9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c4781b9"]])

export default __exports__